import template from './route_progress.html';
import controller from './route_progress.controller';
import './route_progress.scss'

let routeProgressComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default routeProgressComponent;


// WEBPACK FOOTER //
// ./client/app/components/route_progress/route_progress.component.js